import { IRequest } from '@r1-frontend/shared/types/IRequest';

export interface IResponse {
    header: string,
    message: string,
}

interface IData {
    id: number,
    paySum: number,
}

/**
 * Подключение или продление абонемента
 * https://master.api-season-ticket.sandbox.d2c.r-one.io/docs/#/season-ticket/SeasonTicketController_activate
 * @returns IResponse
 */
export const seasonTicketActivate = (providerId: number, data: IData): IRequest => ({
    uri: `/api/v1/${providerId}/season-ticket/activate`,
    method: 'POST',
    withAuth: true,
    body: JSON.stringify(data),
    withProvider: true,
});
